/**
 * Any line with an Experience header and "0 years" (incl. markdown like **0 years**)
 * is normalized for display to entry_level.
 */
export function normalizeJdExperienceZeroToEntryLevel(jdText) {
  if (typeof jdText !== 'string' || !jdText.trim()) return jdText;
  return jdText
    .split(/\r\n|\n|\r/)
    .map((line) => {
      if (!/\bExperience\s*:/i.test(line) || !/\b(?:0\s*years?|zero\s*years?|0\s*yr\.?)\b/i.test(line)) {
        return line;
      }
      return line
        .replace(/\*/g, '')
        .replace(/\b0\s*years?\b/gi, 'entry_level')
        .replace(/\bzero\s*years?\b/gi, 'entry_level')
        .replace(/\b0\s*yr\.?\b/gi, 'entry_level');
    })
    .join('\n');
}
